import(/* webpackMode: "eager" */ "/home/runner/work/eon-service/eon-service/node_modules/@mui/material/Box/index.js");
